// THIS IS A GENERATED FILE
import * as Types from '@gatsbyjs/graphql/types';

import { OrganizationBaseDetailsFragment, PermissionsForOrganizationFragment, OrganizationRepositoriesFragment, OrganizationSiteNamesFragment, OrganizationPlanFeaturesFragment } from './fragments.generated';
import gql from 'graphql-tag';
import { OrganizationBaseDetailsFragmentDoc, PermissionsForOrganizationFragmentDoc, OrganizationRepositoriesFragmentDoc, OrganizationSiteNamesFragmentDoc, OrganizationPlanFeaturesFragmentDoc } from './fragments.generated';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';


export type OrganizationBaseDetailsQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
}>;


export type OrganizationBaseDetailsQuery = (
  { __typename?: 'Query' }
  & { organizationDetails?: Types.Maybe<(
    { __typename?: 'Organization' }
    & OrganizationBaseDetailsFragment
  )> }
);

export type OrganizationRepositoriesQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
  searchText?: Types.Maybe<Types.Scalars['String']>;
  limit?: Types.Maybe<Types.Scalars['Int']>;
  nextCursor?: Types.Maybe<Types.Scalars['String']>;
}>;


export type OrganizationRepositoriesQuery = (
  { __typename?: 'Query' }
  & { organizationDetails?: Types.Maybe<(
    { __typename?: 'Organization' }
    & OrganizationRepositoriesFragment
  )> }
);

export type OrganizationSiteNamesQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
  searchText?: Types.Maybe<Types.Scalars['String']>;
  limit?: Types.Maybe<Types.Scalars['Int']>;
  nextCursor?: Types.Maybe<Types.Scalars['String']>;
}>;


export type OrganizationSiteNamesQuery = (
  { __typename?: 'Query' }
  & { organizationDetails?: Types.Maybe<(
    { __typename?: 'Organization' }
    & OrganizationSiteNamesFragment
  )> }
);

export type OrganizationPermissionsInfoQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
}>;


export type OrganizationPermissionsInfoQuery = (
  { __typename?: 'Query' }
  & { organizationDetails?: Types.Maybe<(
    { __typename?: 'Organization' }
    & Pick<Types.Organization, 'id'>
    & { permissions?: Types.Maybe<(
      { __typename?: 'PermissionsDigest' }
      & PermissionsForOrganizationFragment
    )> }
  )> }
);

export type PlatformLimitSummariesQueryVariables = Types.Exact<{
  workspaceId: Types.Scalars['UUID'];
}>;


export type PlatformLimitSummariesQuery = (
  { __typename?: 'Query' }
  & { platformLimitSummaries?: Types.Maybe<Array<Types.Maybe<(
    { __typename?: 'PlatformLimitSummary' }
    & Pick<Types.PlatformLimitSummary, 'id' | 'name' | 'overage' | 'limit' | 'formattedLimit' | 'overageCount' | 'formattedOverageCount'>
    & { workspace: (
      { __typename?: 'PlatformUsage' }
      & Pick<Types.PlatformUsage, 'count' | 'formattedCount' | 'percentageOfLimit'>
    ) }
  )>>> }
);

export type PlatformLimitSummariesForWorkspacesQueryVariables = Types.Exact<{
  workspaceIds: Array<Types.Scalars['UUID']>;
}>;


export type PlatformLimitSummariesForWorkspacesQuery = (
  { __typename?: 'Query' }
  & { platformLimitSummariesForWorkspaces?: Types.Maybe<Array<Types.Maybe<(
    { __typename?: 'PlatformLimitSummaryForWorkspace' }
    & Pick<Types.PlatformLimitSummaryForWorkspace, 'workspaceId'>
    & { platformLimitSummaries?: Types.Maybe<Array<Types.Maybe<(
      { __typename?: 'PlatformLimitSummary' }
      & Pick<Types.PlatformLimitSummary, 'id' | 'name' | 'overage' | 'limit' | 'formattedLimit' | 'overageCount' | 'formattedOverageCount'>
      & { workspace: (
        { __typename?: 'PlatformUsage' }
        & Pick<Types.PlatformUsage, 'count' | 'formattedCount' | 'percentageOfLimit'>
      ) }
    )>>> }
  )>>> }
);

export type CanInteractWithWorkspaceQueryVariables = Types.Exact<{
  workspaceId: Types.Scalars['UUID'];
  token?: Types.Maybe<Types.Scalars['String']>;
}>;


export type CanInteractWithWorkspaceQuery = (
  { __typename?: 'Query' }
  & Pick<Types.Query, 'canInteractWithWorkspace'>
);

export type HasSsoIntegrationQueryVariables = Types.Exact<{
  workspaceId: Types.Scalars['UUID'];
}>;


export type HasSsoIntegrationQuery = (
  { __typename?: 'Query' }
  & Pick<Types.Query, 'hasSSOIntegration'>
);

export type OrganizationPlanFeaturesQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
}>;


export type OrganizationPlanFeaturesQuery = (
  { __typename?: 'Query' }
  & { organizationDetails?: Types.Maybe<(
    { __typename?: 'Organization' }
    & OrganizationPlanFeaturesFragment
  )> }
);

export type OnPremisesGitConnectionsQueryVariables = Types.Exact<{
  workspaceId: Types.Scalars['UUID'];
}>;


export type OnPremisesGitConnectionsQuery = (
  { __typename?: 'Query' }
  & { publicVcsConfigsByWorkspace?: Types.Maybe<Array<Types.Maybe<(
    { __typename?: 'PublicEnterpriseVcsConfig' }
    & Pick<Types.PublicEnterpriseVcsConfig, 'id' | 'instanceUrl' | 'name' | 'source' | 'status'>
  )>>> }
);

export type OnPremisesGitConnectionByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
}>;


export type OnPremisesGitConnectionByIdQuery = (
  { __typename?: 'Query' }
  & { publicVcsConfigById?: Types.Maybe<(
    { __typename?: 'PublicEnterpriseVcsConfig' }
    & Pick<Types.PublicEnterpriseVcsConfig, 'id' | 'instanceUrl' | 'name' | 'source' | 'status' | 'appSlug'>
  )> }
);


export const OrganizationBaseDetailsDocument = gql`
    query OrganizationBaseDetails($id: UUID!) {
  organizationDetails(id: $id) {
    ...organizationBaseDetails
  }
}
    ${OrganizationBaseDetailsFragmentDoc}`;

/**
 * __useOrganizationBaseDetailsQuery__
 *
 * To run a query within a React component, call `useOrganizationBaseDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationBaseDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationBaseDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationBaseDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrganizationBaseDetailsQuery, OrganizationBaseDetailsQueryVariables>) {
        return ApolloReactHooks.useQuery<OrganizationBaseDetailsQuery, OrganizationBaseDetailsQueryVariables>(OrganizationBaseDetailsDocument, baseOptions);
      }
export function useOrganizationBaseDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationBaseDetailsQuery, OrganizationBaseDetailsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<OrganizationBaseDetailsQuery, OrganizationBaseDetailsQueryVariables>(OrganizationBaseDetailsDocument, baseOptions);
        }
export type OrganizationBaseDetailsQueryHookResult = ReturnType<typeof useOrganizationBaseDetailsQuery>;
export type OrganizationBaseDetailsLazyQueryHookResult = ReturnType<typeof useOrganizationBaseDetailsLazyQuery>;
export type OrganizationBaseDetailsQueryResult = ApolloReactCommon.QueryResult<OrganizationBaseDetailsQuery, OrganizationBaseDetailsQueryVariables>;
export const OrganizationRepositoriesDocument = gql`
    query OrganizationRepositories($id: UUID!, $searchText: String, $limit: Int, $nextCursor: String) {
  organizationDetails(id: $id) {
    ...organizationRepositories
  }
}
    ${OrganizationRepositoriesFragmentDoc}`;

/**
 * __useOrganizationRepositoriesQuery__
 *
 * To run a query within a React component, call `useOrganizationRepositoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationRepositoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationRepositoriesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      nextCursor: // value for 'nextCursor'
 *   },
 * });
 */
export function useOrganizationRepositoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrganizationRepositoriesQuery, OrganizationRepositoriesQueryVariables>) {
        return ApolloReactHooks.useQuery<OrganizationRepositoriesQuery, OrganizationRepositoriesQueryVariables>(OrganizationRepositoriesDocument, baseOptions);
      }
export function useOrganizationRepositoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationRepositoriesQuery, OrganizationRepositoriesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<OrganizationRepositoriesQuery, OrganizationRepositoriesQueryVariables>(OrganizationRepositoriesDocument, baseOptions);
        }
export type OrganizationRepositoriesQueryHookResult = ReturnType<typeof useOrganizationRepositoriesQuery>;
export type OrganizationRepositoriesLazyQueryHookResult = ReturnType<typeof useOrganizationRepositoriesLazyQuery>;
export type OrganizationRepositoriesQueryResult = ApolloReactCommon.QueryResult<OrganizationRepositoriesQuery, OrganizationRepositoriesQueryVariables>;
export const OrganizationSiteNamesDocument = gql`
    query OrganizationSiteNames($id: UUID!, $searchText: String, $limit: Int, $nextCursor: String) {
  organizationDetails(id: $id) {
    ...organizationSiteNames
  }
}
    ${OrganizationSiteNamesFragmentDoc}`;

/**
 * __useOrganizationSiteNamesQuery__
 *
 * To run a query within a React component, call `useOrganizationSiteNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSiteNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationSiteNamesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      nextCursor: // value for 'nextCursor'
 *   },
 * });
 */
export function useOrganizationSiteNamesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrganizationSiteNamesQuery, OrganizationSiteNamesQueryVariables>) {
        return ApolloReactHooks.useQuery<OrganizationSiteNamesQuery, OrganizationSiteNamesQueryVariables>(OrganizationSiteNamesDocument, baseOptions);
      }
export function useOrganizationSiteNamesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationSiteNamesQuery, OrganizationSiteNamesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<OrganizationSiteNamesQuery, OrganizationSiteNamesQueryVariables>(OrganizationSiteNamesDocument, baseOptions);
        }
export type OrganizationSiteNamesQueryHookResult = ReturnType<typeof useOrganizationSiteNamesQuery>;
export type OrganizationSiteNamesLazyQueryHookResult = ReturnType<typeof useOrganizationSiteNamesLazyQuery>;
export type OrganizationSiteNamesQueryResult = ApolloReactCommon.QueryResult<OrganizationSiteNamesQuery, OrganizationSiteNamesQueryVariables>;
export const OrganizationPermissionsInfoDocument = gql`
    query OrganizationPermissionsInfo($id: UUID!) {
  organizationDetails(id: $id) {
    id
    permissions {
      ...permissionsForOrganization
    }
  }
}
    ${PermissionsForOrganizationFragmentDoc}`;

/**
 * __useOrganizationPermissionsInfoQuery__
 *
 * To run a query within a React component, call `useOrganizationPermissionsInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationPermissionsInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationPermissionsInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationPermissionsInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrganizationPermissionsInfoQuery, OrganizationPermissionsInfoQueryVariables>) {
        return ApolloReactHooks.useQuery<OrganizationPermissionsInfoQuery, OrganizationPermissionsInfoQueryVariables>(OrganizationPermissionsInfoDocument, baseOptions);
      }
export function useOrganizationPermissionsInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationPermissionsInfoQuery, OrganizationPermissionsInfoQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<OrganizationPermissionsInfoQuery, OrganizationPermissionsInfoQueryVariables>(OrganizationPermissionsInfoDocument, baseOptions);
        }
export type OrganizationPermissionsInfoQueryHookResult = ReturnType<typeof useOrganizationPermissionsInfoQuery>;
export type OrganizationPermissionsInfoLazyQueryHookResult = ReturnType<typeof useOrganizationPermissionsInfoLazyQuery>;
export type OrganizationPermissionsInfoQueryResult = ApolloReactCommon.QueryResult<OrganizationPermissionsInfoQuery, OrganizationPermissionsInfoQueryVariables>;
export const PlatformLimitSummariesDocument = gql`
    query PlatformLimitSummaries($workspaceId: UUID!) {
  platformLimitSummaries(workspaceId: $workspaceId) {
    id
    name
    overage
    limit
    formattedLimit
    overageCount
    formattedOverageCount
    workspace {
      count
      formattedCount
      percentageOfLimit
    }
  }
}
    `;

/**
 * __usePlatformLimitSummariesQuery__
 *
 * To run a query within a React component, call `usePlatformLimitSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlatformLimitSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlatformLimitSummariesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function usePlatformLimitSummariesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PlatformLimitSummariesQuery, PlatformLimitSummariesQueryVariables>) {
        return ApolloReactHooks.useQuery<PlatformLimitSummariesQuery, PlatformLimitSummariesQueryVariables>(PlatformLimitSummariesDocument, baseOptions);
      }
export function usePlatformLimitSummariesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlatformLimitSummariesQuery, PlatformLimitSummariesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<PlatformLimitSummariesQuery, PlatformLimitSummariesQueryVariables>(PlatformLimitSummariesDocument, baseOptions);
        }
export type PlatformLimitSummariesQueryHookResult = ReturnType<typeof usePlatformLimitSummariesQuery>;
export type PlatformLimitSummariesLazyQueryHookResult = ReturnType<typeof usePlatformLimitSummariesLazyQuery>;
export type PlatformLimitSummariesQueryResult = ApolloReactCommon.QueryResult<PlatformLimitSummariesQuery, PlatformLimitSummariesQueryVariables>;
export const PlatformLimitSummariesForWorkspacesDocument = gql`
    query PlatformLimitSummariesForWorkspaces($workspaceIds: [UUID!]!) {
  platformLimitSummariesForWorkspaces(workspaceIds: $workspaceIds) {
    workspaceId
    platformLimitSummaries {
      id
      name
      overage
      limit
      formattedLimit
      overageCount
      formattedOverageCount
      workspace {
        count
        formattedCount
        percentageOfLimit
      }
    }
  }
}
    `;

/**
 * __usePlatformLimitSummariesForWorkspacesQuery__
 *
 * To run a query within a React component, call `usePlatformLimitSummariesForWorkspacesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlatformLimitSummariesForWorkspacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlatformLimitSummariesForWorkspacesQuery({
 *   variables: {
 *      workspaceIds: // value for 'workspaceIds'
 *   },
 * });
 */
export function usePlatformLimitSummariesForWorkspacesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PlatformLimitSummariesForWorkspacesQuery, PlatformLimitSummariesForWorkspacesQueryVariables>) {
        return ApolloReactHooks.useQuery<PlatformLimitSummariesForWorkspacesQuery, PlatformLimitSummariesForWorkspacesQueryVariables>(PlatformLimitSummariesForWorkspacesDocument, baseOptions);
      }
export function usePlatformLimitSummariesForWorkspacesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlatformLimitSummariesForWorkspacesQuery, PlatformLimitSummariesForWorkspacesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<PlatformLimitSummariesForWorkspacesQuery, PlatformLimitSummariesForWorkspacesQueryVariables>(PlatformLimitSummariesForWorkspacesDocument, baseOptions);
        }
export type PlatformLimitSummariesForWorkspacesQueryHookResult = ReturnType<typeof usePlatformLimitSummariesForWorkspacesQuery>;
export type PlatformLimitSummariesForWorkspacesLazyQueryHookResult = ReturnType<typeof usePlatformLimitSummariesForWorkspacesLazyQuery>;
export type PlatformLimitSummariesForWorkspacesQueryResult = ApolloReactCommon.QueryResult<PlatformLimitSummariesForWorkspacesQuery, PlatformLimitSummariesForWorkspacesQueryVariables>;
export const CanInteractWithWorkspaceDocument = gql`
    query canInteractWithWorkspace($workspaceId: UUID!, $token: String) {
  canInteractWithWorkspace(workspaceId: $workspaceId, token: $token)
}
    `;

/**
 * __useCanInteractWithWorkspaceQuery__
 *
 * To run a query within a React component, call `useCanInteractWithWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanInteractWithWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanInteractWithWorkspaceQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useCanInteractWithWorkspaceQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CanInteractWithWorkspaceQuery, CanInteractWithWorkspaceQueryVariables>) {
        return ApolloReactHooks.useQuery<CanInteractWithWorkspaceQuery, CanInteractWithWorkspaceQueryVariables>(CanInteractWithWorkspaceDocument, baseOptions);
      }
export function useCanInteractWithWorkspaceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CanInteractWithWorkspaceQuery, CanInteractWithWorkspaceQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<CanInteractWithWorkspaceQuery, CanInteractWithWorkspaceQueryVariables>(CanInteractWithWorkspaceDocument, baseOptions);
        }
export type CanInteractWithWorkspaceQueryHookResult = ReturnType<typeof useCanInteractWithWorkspaceQuery>;
export type CanInteractWithWorkspaceLazyQueryHookResult = ReturnType<typeof useCanInteractWithWorkspaceLazyQuery>;
export type CanInteractWithWorkspaceQueryResult = ApolloReactCommon.QueryResult<CanInteractWithWorkspaceQuery, CanInteractWithWorkspaceQueryVariables>;
export const HasSsoIntegrationDocument = gql`
    query hasSSOIntegration($workspaceId: UUID!) {
  hasSSOIntegration(workspaceId: $workspaceId)
}
    `;

/**
 * __useHasSsoIntegrationQuery__
 *
 * To run a query within a React component, call `useHasSsoIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasSsoIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasSsoIntegrationQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useHasSsoIntegrationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HasSsoIntegrationQuery, HasSsoIntegrationQueryVariables>) {
        return ApolloReactHooks.useQuery<HasSsoIntegrationQuery, HasSsoIntegrationQueryVariables>(HasSsoIntegrationDocument, baseOptions);
      }
export function useHasSsoIntegrationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HasSsoIntegrationQuery, HasSsoIntegrationQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<HasSsoIntegrationQuery, HasSsoIntegrationQueryVariables>(HasSsoIntegrationDocument, baseOptions);
        }
export type HasSsoIntegrationQueryHookResult = ReturnType<typeof useHasSsoIntegrationQuery>;
export type HasSsoIntegrationLazyQueryHookResult = ReturnType<typeof useHasSsoIntegrationLazyQuery>;
export type HasSsoIntegrationQueryResult = ApolloReactCommon.QueryResult<HasSsoIntegrationQuery, HasSsoIntegrationQueryVariables>;
export const OrganizationPlanFeaturesDocument = gql`
    query OrganizationPlanFeatures($id: UUID!) {
  organizationDetails(id: $id) {
    ...organizationPlanFeatures
  }
}
    ${OrganizationPlanFeaturesFragmentDoc}`;

/**
 * __useOrganizationPlanFeaturesQuery__
 *
 * To run a query within a React component, call `useOrganizationPlanFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationPlanFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationPlanFeaturesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationPlanFeaturesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrganizationPlanFeaturesQuery, OrganizationPlanFeaturesQueryVariables>) {
        return ApolloReactHooks.useQuery<OrganizationPlanFeaturesQuery, OrganizationPlanFeaturesQueryVariables>(OrganizationPlanFeaturesDocument, baseOptions);
      }
export function useOrganizationPlanFeaturesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationPlanFeaturesQuery, OrganizationPlanFeaturesQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<OrganizationPlanFeaturesQuery, OrganizationPlanFeaturesQueryVariables>(OrganizationPlanFeaturesDocument, baseOptions);
        }
export type OrganizationPlanFeaturesQueryHookResult = ReturnType<typeof useOrganizationPlanFeaturesQuery>;
export type OrganizationPlanFeaturesLazyQueryHookResult = ReturnType<typeof useOrganizationPlanFeaturesLazyQuery>;
export type OrganizationPlanFeaturesQueryResult = ApolloReactCommon.QueryResult<OrganizationPlanFeaturesQuery, OrganizationPlanFeaturesQueryVariables>;
export const OnPremisesGitConnectionsDocument = gql`
    query OnPremisesGitConnections($workspaceId: UUID!) {
  publicVcsConfigsByWorkspace(workspaceId: $workspaceId) {
    id
    instanceUrl
    name
    source
    status
  }
}
    `;

/**
 * __useOnPremisesGitConnectionsQuery__
 *
 * To run a query within a React component, call `useOnPremisesGitConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnPremisesGitConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnPremisesGitConnectionsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useOnPremisesGitConnectionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OnPremisesGitConnectionsQuery, OnPremisesGitConnectionsQueryVariables>) {
        return ApolloReactHooks.useQuery<OnPremisesGitConnectionsQuery, OnPremisesGitConnectionsQueryVariables>(OnPremisesGitConnectionsDocument, baseOptions);
      }
export function useOnPremisesGitConnectionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OnPremisesGitConnectionsQuery, OnPremisesGitConnectionsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<OnPremisesGitConnectionsQuery, OnPremisesGitConnectionsQueryVariables>(OnPremisesGitConnectionsDocument, baseOptions);
        }
export type OnPremisesGitConnectionsQueryHookResult = ReturnType<typeof useOnPremisesGitConnectionsQuery>;
export type OnPremisesGitConnectionsLazyQueryHookResult = ReturnType<typeof useOnPremisesGitConnectionsLazyQuery>;
export type OnPremisesGitConnectionsQueryResult = ApolloReactCommon.QueryResult<OnPremisesGitConnectionsQuery, OnPremisesGitConnectionsQueryVariables>;
export const OnPremisesGitConnectionByIdDocument = gql`
    query OnPremisesGitConnectionById($id: UUID!) {
  publicVcsConfigById(id: $id) {
    id
    instanceUrl
    name
    source
    status
    appSlug
  }
}
    `;

/**
 * __useOnPremisesGitConnectionByIdQuery__
 *
 * To run a query within a React component, call `useOnPremisesGitConnectionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnPremisesGitConnectionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnPremisesGitConnectionByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOnPremisesGitConnectionByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OnPremisesGitConnectionByIdQuery, OnPremisesGitConnectionByIdQueryVariables>) {
        return ApolloReactHooks.useQuery<OnPremisesGitConnectionByIdQuery, OnPremisesGitConnectionByIdQueryVariables>(OnPremisesGitConnectionByIdDocument, baseOptions);
      }
export function useOnPremisesGitConnectionByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OnPremisesGitConnectionByIdQuery, OnPremisesGitConnectionByIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<OnPremisesGitConnectionByIdQuery, OnPremisesGitConnectionByIdQueryVariables>(OnPremisesGitConnectionByIdDocument, baseOptions);
        }
export type OnPremisesGitConnectionByIdQueryHookResult = ReturnType<typeof useOnPremisesGitConnectionByIdQuery>;
export type OnPremisesGitConnectionByIdLazyQueryHookResult = ReturnType<typeof useOnPremisesGitConnectionByIdLazyQuery>;
export type OnPremisesGitConnectionByIdQueryResult = ApolloReactCommon.QueryResult<OnPremisesGitConnectionByIdQuery, OnPremisesGitConnectionByIdQueryVariables>;
